export function resolveOpenDockPdfReportsAccess({
  hasSession,
  isOpenDock,
  isFlagLoading,
  isFlagEnabled,
  isFetched,
  isForbidden = false,
}: {
  hasSession: boolean
  isOpenDock: boolean
  isFlagLoading: boolean
  isFlagEnabled: boolean | null
  isFetched: boolean
  isForbidden?: boolean
}) {
  const flagOn = isFlagEnabled === true
  const shouldFetch = !isFlagLoading && hasSession && isOpenDock && flagOn

  return {
    shouldFetch,
    isNavVisible: shouldFetch && isFetched && !isForbidden,
    isLoading: isFlagLoading || (shouldFetch && !isFetched),
  }
}
